/**
 * BrandAuditDetailPresenter
 * --
 */
import React from 'react';

/**----------------------------------------
 * [Component] 입점업체 심사 상세
 * ----------------------------------------
 */
const BrandAuditDetailPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <div>
      <p>BrandAuditDetailPresenter</p>
    </div>
  );
};

export default BrandAuditDetailPresenter;
